import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  // Check if user is logged in from either localStorage or sessionStorage
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true' || 
                     sessionStorage.getItem('isLoggedIn') === 'true';
  
  // If not logged in, redirect to login page
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // If logged in, render the protected component
  return children;
};

export default PrivateRoute;